import { ToastContainer } from "react-toastify";
export const withToastify = (children) => () => (
  <>
    <ToastContainer />
    {children()}
  </>
);
